import type {TableColumnSetupItem} from '@yandex-data-ui/common/build/esm/components/TableColumnSetup2/TableColumnSetup';
import type {YfmEditorType} from '@yandex-data-ui/yfm-editor';

export enum Lang {
    Ru = 'ru',
    En = 'en',
}

export enum Theme {
    Light = 'light',
    Dark = 'dark',
    System = 'system',
    LightHighContrast = 'light-hc',
    DarkHighContrast = 'dark-hc',
}

export enum ThemeContrast {
    High = 'hc',
    Normal = 'normal',
}

export interface ThemeSettings {
    systemLightTheme: Theme.Light | Theme.LightHighContrast;
    systemDarkTheme: Theme.Dark | Theme.DarkHighContrast;
}

export interface WikiEditableUserSettings extends WikiUntypedUserSettings {
    language: Lang;
    theme: Theme;
    propose_content_translation: boolean;
    data_ui_web?: boolean;
    wysiwyg_editor?: boolean;
    wiki_editor?: boolean;
    fast_create?: boolean;
    /** @default false */
    hide_inline_comments_informer?: boolean;
    new_year?: boolean;
}

export interface WikiUserSettings extends WikiEditableUserSettings {
    // uneditable settings
    show_features_pages: boolean;
}

export type TableSettings = Array<TableColumnSetting>;

export interface TableColumnSetting extends TableColumnSetupItem {
    id: string;
}

export type SidePanelId = 'toc' | 'comments' | 'attachments' | 'revisions' | 'search';

export interface WikiUntypedUserSettings {
    favoritesTable?: TableSettings;
    subscriptionsTable?: TableSettings;
    autoBookmarksTable?: TableSettings;
    recoveryTokens?: TableSettings;
    navigationTreeOpened?: boolean;
    wysiwygAnounceVisible?: boolean;
    editorSettings?: {
        editorType?: YfmEditorType;
        editorMenuVisibility?: boolean;
        editorSplitModeEnabled?: boolean;
    };
    sidePanel?: {
        visible: boolean;
        active?: SidePanelId;
    };
    themeSettings: ThemeSettings;
}
